import * as tslib_1 from "tslib";
import { Candidate } from '../../../models/candidate';
import { CandidatesQueryFilter } from '../../../models/candidatesQueryFilter';
import { CandidateDisplayQueryFilter } from '../../../models/candidateDisplayQueryFilter';
var CandidatesPageController = /** @class */ (function () {
    /*@ngInject*/
    function CandidatesPageController($scope, $rootScope, $timeout, $filter, StorageService, genericService, jobService, candidateService, jobMatchService, companyService, userRoleService, stateManagementStorageService, alertsAndNotificationsService, MESSAGECONSTANTS, sharedAjsService) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.StorageService = StorageService;
        this.genericService = genericService;
        this.jobService = jobService;
        this.candidateService = candidateService;
        this.jobMatchService = jobMatchService;
        this.companyService = companyService;
        this.userRoleService = userRoleService;
        this.stateManagementStorageService = stateManagementStorageService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.sharedAjsService = sharedAjsService;
    }
    CandidatesPageController.prototype.$onInit = function () {
        //variables
        this.$stateParams = this.$transition$.params();
        this.candidates = [];
        this.salaryDurationOptions = [];
        this.filterSalaryDurationOptions = [];
        this.filterRateDurationOptions = [];
        this.selectedJobMatchStates = [];
        this.jobMatchStates = [];
        this.candidatesCount = 0;
        this.candidatesContainer = null;
        this.userId = null;
        this.infoOfCandidateInContext = null;
        this.companyType = null;
        this.clientOrBuList = null;
        this.candidateStatusList = null;
        this.requisitionStatusList = null;
        this.recruitersList = [];
        this.vendors = [];
        this.requisitionNumbersList = null;
        this.candidateInfoTemplate = '';
        this.candidateInfoContainerId = null;
        this.selectedDateRange = '';
        this.activityMap = [];
        this.divident = 4;
        this.activeTabIndex = 1;
        this.showFiltersPanel = false;
        this.isFiltersChanged = false;
        this.savedFilters = null;
        this.visibilityFilters = {
            unassigned: '',
            assignedToMe: '',
            assignedToOthers: ''
        };
        this.sortByFilters = [
            {
                "column": "status",
                "columnDisplayName": "Candidate Status"
            },
            {
                "column": "createdDate",
                "columnDisplayName": "Creation Date"
            },
            {
                "column": "email",
                "columnDisplayName": "Email"
            },
            {
                "column": "firstName",
                "columnDisplayName": "First Name"
            },
            {
                "column": "lastName",
                "columnDisplayName": "Last Name"
            },
            {
                "column": "updatedDate",
                "columnDisplayName": "Most Recently Updated"
            },
            {
                "column": "phone",
                "columnDisplayName": "Phone"
            },
            {
                "column": "recruiterList",
                "columnDisplayName": "Recruiters"
            },
            {
                "column": "requisitionNumbers",
                "columnDisplayName": "Requisition Number"
            },
            {
                "column": "requisitionStatus",
                "columnDisplayName": "Requisition Status"
            }
        ];
        this.selectedSort = 'Please Select';
        this.selectedSortDirection = '';
        // selected lists
        this.selectedClientOrBuList = [];
        this.selectedRequisitionStatusList = [];
        this.selectedRecruitersList = [];
        this.selectedVendors = [];
        this.selectedRequisitionNumbersList = [];
        this.candidateFilterItemsSelected = [];
        this.selectedPreferredJobTypeAdditionalList = [];
        this.candidateJobMatchActiveTab = {};
        // this.selectedCandidateStatusList = ["Active","Passive","Inert"];
        //flags
        this.isVendorCompany = false;
        this.hideSearchStringFlag = false;
        this.candidatesExistFlag = true;
        this.showCandidateInfo = false;
        this.loadingClientsOrBusFilter = true;
        this.loadingCandidateStatusesFilter = true;
        this.loadingRequisitionStatusesFilter = true;
        this.loadingRequisitionNumbersFilter = true;
        this.loadingJobMatchStatesFilter = true;
        this.loadingVendorsFilter = true;
        this.loadingRecruitersFilter = true;
        this.loadingWorkLocationsFilter = true;
        this.emptyCandidateSelectedFilter = false;
        this.loadingPreferredJobTypeFilter = true;
        this.loadingWorkAuthorizationFilter = true;
        this.loadingAdditionalPreferredJobTypeFilter = true;
        this.isDisplayRateFilterActive = false;
        this.queryCandidates = _.debounce(this.queryCandidates, 900);
        this.init();
        this._handleFilterDisplay();
    };
    CandidatesPageController.prototype.init = function () {
        var _this = this;
        if (window.innerWidth < 1400) {
            this.divident = 3;
        }
        this.isVendorCompany = this.companyService.isCompanyVendor();
        this.candidates = [];
        this.candidatesContainer = new CandidatesContainer(this.$rootScope, this.divident, this.candidateService, this.alertsAndNotificationsService);
        this.userId = this.$rootScope.userDetails.id;
        this.userName = this.$rootScope.userDetails.firstname + ' ' + this.$rootScope.userDetails.lastname;
        this.companyType = this.$rootScope.userDetails.company.companyType;
        if (this.companyType == "StaffingCompany") {
            var clientOrBu = {
                "column": "clientOrBuList",
                "columnDisplayName": "Client"
            };
            this.sortByFilters.splice(1, 0, clientOrBu);
        }
        else {
            var clientOrBu = {
                "column": "clientOrBuList",
                "columnDisplayName": "BU"
            };
            this.sortByFilters.splice(0, 0, clientOrBu);
        }
        // Remove candidate screen on company switch (in super user)
        this._checkAndRemoveIfFilterExistsWithCompanyId();
        var savedFilters = this.stateManagementStorageService.getScreenState("candidatesScreen-" + this.userId);
        this.defaultFilters = new CandidatesQueryFilter(this.$rootScope.userDetails.company.companyId, this.$rootScope.userDetails.id);
        if (savedFilters && this.$stateParams.searchString == null
            && this.$stateParams.candidateStatuses == null
            && this.$stateParams.recruiters == null
            && this.$stateParams.visibilityFilters == null
            && this.$stateParams.searchString == null
            && this.$stateParams.candidateType == null
            && this._checkIfNewFiltersAdded(this.defaultFilters, savedFilters)) {
            this.candidatesContainer.candidatesQueryFilter = angular.copy(savedFilters);
            this.savedFilters = angular.copy(savedFilters);
        }
        else {
            this._setSalaryAndRate();
            this.stateManagementStorageService.setScreenState("candidatesScreen-" + this.userId, this.defaultFilters);
        }
        // Display Selected Filters
        this.displayCandidateSelectedFilter = new CandidateDisplayQueryFilter();
        var savedDisplayedCandidateSelectedFilter = this.stateManagementStorageService.getScreenState("candidatesScreen-displayFilter-" + this.userId);
        if (savedDisplayedCandidateSelectedFilter && this._checkIfNewFiltersAdded(this.displayCandidateSelectedFilter, savedDisplayedCandidateSelectedFilter)) {
            if (this.$stateParams.candidateStatuses) {
                savedDisplayedCandidateSelectedFilter.searchString = "";
                this.stateManagementStorageService.setScreenState("candidatesScreen-displayFilter-" + this.userId, savedDisplayedCandidateSelectedFilter);
            }
            this.displayCandidateSelectedFilter = angular.copy(savedDisplayedCandidateSelectedFilter);
            // Set Sort By Filter to Null
            // this.displayCandidateSelectedFilter.selectedFilterSort = "";
            this.savedDisplayedCandidateSelectedFilter = angular.copy(savedDisplayedCandidateSelectedFilter);
            if (_.isUndefined(this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon)) {
                this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon = true;
            }
        }
        else {
            this.stateManagementStorageService.setScreenState("candidatesScreen-displayFilter-" + this.userId, this.displayCandidateSelectedFilter);
            this.savedDisplayedCandidateSelectedFilter = angular.copy(this.displayCandidateSelectedFilter);
        }
        this.showCandidateDisplaySelectedFilterPanel = this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon;
        this._setStateParamsFilter();
        // this._setCandidatesTypeFilter();
        this._setCandidatesSortFilter();
        // get all the filter data
        this.getAllClientsOrBu(function () {
            _this.getAllRequisitionNumbers(function () {
                _this.getAllRecruiters(function () {
                    // check if any state params are present and add them onto the filters
                    if (!_.isNull(_this.$stateParams.recruiters) && _.isArray(_this.$stateParams.recruiters)) {
                        _this.candidatesContainer.candidatesQueryFilter.recruiterList = _this.$stateParams.recruiters;
                        _this._setFilterValues('Recruiters', _this.$stateParams.recruiters);
                    }
                    _this.getAllRequisitionStatuses(function () {
                        _this.getAllWorkLocations(function () {
                            _this.getAllJobMatchStates(function () {
                                if (_this.companyType == 'Corporation') {
                                    _this.getAllVendors(function () {
                                        _this.savedFilters = null;
                                    });
                                }
                                else {
                                    _this.loadingVendorsFilter = false;
                                    _this.savedFilters = null;
                                }
                            });
                        });
                    });
                });
            });
        });
        this.getAllCandidateStatuses(function () {
            // check if any state params are present and add them onto the filters
            if (!_.isNull(_this.$stateParams.candidateStatuses) && _.isArray(_this.$stateParams.candidateStatuses)) {
                _this.candidatesContainer.candidatesQueryFilter.status = _this.$stateParams.candidateStatuses;
                _this._setFilterValues('CandidateStatus', _this.$stateParams.candidateStatuses);
            }
        });
        this.getAllActivityTypes();
        this.getSalaryDurationOptions();
        this.getAllPreferredJobTypes();
        this.getAllAdditionalPreferredJobTypes();
        this.getAllWorkAuthorizations();
        this.getCurrencyCodes();
        this._setDisplaySalaryAndRateFilter();
        this.isRowViewActive = false;
        this.currentCandidatePage = 1;
        this._setCandidateRowViewStatus();
    };
    CandidatesPageController.prototype._setCandidateRowViewStatus = function () {
        var checkIfRowViewActive = this.stateManagementStorageService.getScreenState("candidatesScreen-rowView-" + this.userId);
        if (checkIfRowViewActive) {
            this.isRowViewActive = checkIfRowViewActive.isRowViewActive;
            if (this.isRowViewActive) {
                this.candidatesContainer.getNextPage(this.currentCandidatePage);
            }
        }
    };
    CandidatesPageController.prototype.toggleCandidateRowView = function () {
        this.isRowViewActive = !this.isRowViewActive;
        this.stateManagementStorageService.setScreenState("candidatesScreen-rowView-" + this.userId, { isRowViewActive: this.isRowViewActive });
        if (this.isRowViewActive) {
            this.closeCandidateInfoRow();
            this.candidatesContainer.getNextPage(this.currentCandidatePage);
        }
        else {
            // Reset Candidate card view
            this.candidatesContainer.candidatesExistFlag = true;
            this.candidatesContainer.candidatesQueryFilter.pageNum = 1;
            this.candidatesContainer.candidates = [];
            this.candidatesContainer.disableInfiniteScroll = false;
        }
    };
    CandidatesPageController.prototype._checkIfNewFiltersAdded = function (defaultFilters, savedFilters) {
        var checkIfFilterIsOld = Object.keys(defaultFilters).every(function (filter) {
            return Object.keys(savedFilters).includes(filter);
        });
        return checkIfFilterIsOld;
    };
    CandidatesPageController.prototype._checkAndRemoveIfFilterExistsWithCompanyId = function () {
        var existingCandidateScreenState = this.stateManagementStorageService.getScreenState("candidatesScreen-" + this.userId);
        if (existingCandidateScreenState) {
            if (existingCandidateScreenState.parentCompanyId !== this.$rootScope.userDetails.company.companyId) {
                this.stateManagementStorageService.clearStateScreen("candidatesScreen-" + this.userId);
                this.stateManagementStorageService.clearStateScreen("candidatesScreen-displayFilter-" + this.userId);
            }
        }
    };
    CandidatesPageController.prototype._setStateParamsFilter = function () {
        if (this.$stateParams.searchString && this.$stateParams.searchString != '') {
            // Reset Filters
            this.defaultFilters = new CandidatesQueryFilter(this.$rootScope.userDetails.company.companyId, this.$rootScope.userDetails.id);
            this.candidatesContainer.candidatesQueryFilter = angular.copy(this.defaultFilters);
            this.candidatesContainer.candidatesQueryFilter.searchString = this.$stateParams.searchString;
            this.stateManagementStorageService.setScreenState("candidatesScreen-" + this.userId, this.candidatesContainer.candidatesQueryFilter);
            this.savedFilters = angular.copy(this.candidatesContainer.candidatesQueryFilter);
            // Reset Display Filters
            this.displayCandidateSelectedFilter = new CandidateDisplayQueryFilter();
            this.displayCandidateSelectedFilter.searchString = this.candidatesContainer.candidatesQueryFilter.searchString;
            this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
            this.stateManagementStorageService.setScreenState("candidatesScreen-displayFilter-" + this.userId, this.displayCandidateSelectedFilter);
            this.savedDisplayedCandidateSelectedFilter = angular.copy(this.displayCandidateSelectedFilter);
        }
        if (!_.isNull(this.$stateParams.visibilityFilters)) {
            this.visibilityFilters = this.$stateParams.visibilityFilters;
            if (this.visibilityFilters.unassigned != '') {
                this.candidatesContainer.candidatesQueryFilter.visibility.push('unassigned');
            }
            if (this.visibilityFilters.assignedToMe != '') {
                this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToMe');
            }
            if (this.visibilityFilters.assignedToOthers != '') {
                this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToOthers');
            }
        }
        else {
            this.candidatesContainer.candidatesQueryFilter.visibility.push('unassigned');
            this.visibilityFilters.unassigned = 'unassigned';
            this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToOthers');
            this.visibilityFilters.assignedToOthers = 'assignedToOthers';
            this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToMe');
            this.visibilityFilters.assignedToMe = 'assignedToMe';
        }
        if (!_.isNull(this.$stateParams.candidateType)) {
            this.candidatesContainer.candidatesQueryFilter.candidateType = this.$stateParams.candidateType;
        }
        this.StorageService.set('candidatesType', this.candidatesContainer.candidatesQueryFilter.candidateType);
    };
    // _setCandidatesTypeFilter() {
    //     let previouslySelectedCandidatesType = this.StorageService.get('candidatesType');
    //     if(!_.isNull(this.$stateParams.candidateType)) {
    //         this.candidatesContainer.candidatesQueryFilter.candidateType = this.$stateParams.candidateType;
    //     } else if(!_.isNull(previouslySelectedCandidatesType) && previouslySelectedCandidatesType !== undefined && this.companyType == 'Corporation') {
    //         this.candidatesContainer.candidatesQueryFilter.candidateType = previouslySelectedCandidatesType;
    //     } else {
    //         this.candidatesContainer.candidatesQueryFilter.candidateType = "OWN_CANDIDATES";
    //     }
    //     this.StorageService.set('candidatesType', this.candidatesContainer.candidatesQueryFilter.candidateType);
    // }
    CandidatesPageController.prototype._setCandidatesSortFilter = function () {
        var _this = this;
        if (!_.isNull(this.savedFilters) && !_.isUndefined(this.savedFilters.sortDirection) && !_.isUndefined(this.savedFilters.column)) {
            // let sortByFilter = this.StorageService.get(`candidatesSortFilter-${this.userId}`);
            // if(!_.isNull(sortByFilter) && !_.isUndefined(sortByFilter)){
            //     this.selectedSort = sortByFilter.sortBy.columnDisplayName;
            //     this.candidatesContainer.candidatesQueryFilter.column = sortByFilter.sortBy.column;
            //     this.selectedSortDirection = 'Asc';
            //     this.candidatesContainer.candidatesQueryFilter.sortDirection = 'ASC';
            //     if(sortByFilter.direction == 'Desc') {
            //         this.selectedSortDirection = 'Desc';
            //         this.candidatesContainer.candidatesQueryFilter.sortDirection = 'DESC';
            //     }
            // }
            this.sortByFilters.forEach(function (filter) {
                if (filter.column == _this.savedFilters.column) {
                    _this.selectedSort = filter.columnDisplayName;
                }
            });
            this.candidatesContainer.candidatesQueryFilter.column = this.savedFilters.column;
            if (this.savedFilters.sortDirection == 'DESC') {
                this.selectedSortDirection = 'Desc';
                this.candidatesContainer.candidatesQueryFilter.sortDirection = 'DESC';
            }
            else {
                this.selectedSortDirection = 'Asc';
                this.candidatesContainer.candidatesQueryFilter.sortDirection = 'ASC';
            }
        }
        if (this.savedDisplayedCandidateSelectedFilter.selectedFilterSort.length > 0 || this.savedDisplayedCandidateSelectedFilter.searchString.length > 0) {
            this.setCandidateDisplayedFilterItemSelected(this.savedDisplayedCandidateSelectedFilter);
        }
    };
    CandidatesPageController.prototype.onCandidatesTypeChanged = function () {
        this.candidateInfoContainerId = null;
        this.candidateJobMatchesTabChanged('jobMatches');
        this.StorageService.set('candidatesType', this.candidatesContainer.candidatesQueryFilter.candidateType);
        this.queryCandidates();
        if (this.candidatesContainer.candidatesQueryFilter.candidateType === 'OWN_CANDIDATES') {
            this.displayCandidateSelectedFilter.vendors = [];
            this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
        }
        else {
            this.onVendorClick();
            this._setSalaryAndRateDefaultValues('salary');
            this._setSalaryAndRateDefaultValues('rate');
            this.displayCandidateSelectedFilter.salary = "";
            this.displayCandidateSelectedFilter.rate = "";
            this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
        }
    };
    CandidatesPageController.prototype.getAllVendors = function (successCallback) {
        var _this = this;
        this.loadingVendorsFilter = true;
        this.companyService.getVendorsByUserScope(this.$rootScope.userDetails.company.companyId, function (data) {
            _this.vendors = data;
            _this.loadingVendorsFilter = false;
            if (_this.savedFilters !== null) {
                _this.selectedVendors = _this.vendors.filter(function (vendor) { return _this.savedFilters.vendors.some(function (vendorId) { return vendorId == vendor.id; }); });
                _this.selectedVendors.forEach(function (vendor) { return vendor.ticked = true; });
            }
            if (_this.savedDisplayedCandidateSelectedFilter.vendors.length !== 0 || _this.candidatesContainer.candidatesQueryFilter.vendors.length !== 0) {
                _this.displayCandidateSelectedFilter.vendors = _this.selectedVendors.map(function (val, index) {
                    return val.name;
                });
                _this.setCandidateDisplayedFilterItemSelected(_this.displayCandidateSelectedFilter);
            }
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.loadingVendorsFilter = false;
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CandidatesPageController.prototype.resetCandidateQueryFilters = function () {
        this.isFiltersChanged = true;
        this.selectedDateRange = '';
        angular.forEach(this.candidateStatusList, function (val, key) {
            val.ticked = false;
        });
        angular.forEach(this.recruitersList, function (val, key) {
            val.ticked = false;
        });
        angular.forEach(this.vendors, function (val, key) {
            val.ticked = false;
        });
        angular.forEach(this.requisitionNumbersList, function (val, key) {
            val.ticked = false;
        });
        angular.forEach(this.requisitionStatusList, function (val, key) {
            val.ticked = false;
        });
        angular.forEach(this.clientOrBuList, function (val, key) {
            val.ticked = false;
        });
        angular.forEach(this.jobMatchStates, function (val, key) {
            val.ticked = false;
        });
        angular.forEach(this.workLocationList, function (val, key) {
            val.ticked = false;
        });
        angular.forEach(this.preferredJobTypeList, function (val, key) {
            val.ticked = false;
        });
        angular.forEach(this.preferredJobTypeAdditionalList, function (val, key) {
            val.ticked = false;
        });
        angular.forEach(this.workAuthorizationList, function (val, key) {
            val.ticked = false;
        });
        if (this.selectedSort != "Please Select") {
            this.selectedSort = "Please Select";
            this.selectedSortDirection = "";
            delete (this.candidatesContainer.candidatesQueryFilter.column);
            delete (this.candidatesContainer.candidatesQueryFilter.sortDirection);
        }
        this.candidatesContainer.candidatesQueryFilter = new CandidatesQueryFilter(this.$rootScope.userDetails.company.companyId, this.$rootScope.userDetails.id);
        // Reset Salary and Rate
        this._setSalaryAndRate();
        //to set existing visibility filters
        this.candidatesContainer.candidatesQueryFilter.visibility.push('unassigned');
        this.visibilityFilters.unassigned = 'unassigned';
        this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToOthers');
        this.visibilityFilters.assignedToOthers = 'assignedToOthers';
        this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToMe');
        this.visibilityFilters.assignedToMe = 'assignedToMe';
        // this.visibilityFilterChanged();
        // Reset Displayed Selected Filters
        this.displayCandidateSelectedFilter = new CandidateDisplayQueryFilter();
        var savedDisplayedCandidateSelectedFilter = this.stateManagementStorageService.getScreenState("candidatesScreen-displayFilter-" + this.userId);
        this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon = savedDisplayedCandidateSelectedFilter.showCandidateDisplayFilterIcon;
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    };
    CandidatesPageController.prototype._setFilterValues = function (label, arrayOfFilterValues) {
        switch (label) {
            case 'CandidateStatus':
                angular.forEach(this.candidateStatusList, function (candidateStatus, key) {
                    if (arrayOfFilterValues.indexOf(candidateStatus.value) != -1) {
                        candidateStatus.ticked = true;
                    }
                });
                break;
            case 'Recruiters':
                angular.forEach(this.recruitersList, function (recruiter, key) {
                    if (arrayOfFilterValues.indexOf(recruiter.userId) != -1) {
                        recruiter.ticked = true;
                    }
                });
                break;
            default:
                break;
        }
    };
    CandidatesPageController.prototype.selectRemoveAll = function (label, type, doQueryFlag) {
        if (type == 'selectAll') {
            switch (label) {
                case 'Clients':
                    this.selectedClientOrBuList = tslib_1.__spread(this.clientOrBuList);
                    this.onClientClick();
                    break;
                case 'CandidateStatus':
                    this.selectedCandidateStatusList = tslib_1.__spread(this.candidateStatusList);
                    this.onCandidateStatusClick();
                    break;
                case 'RequisitionStatus':
                    this.selectedRequisitionStatusList = tslib_1.__spread(this.requisitionStatusList);
                    this.onRequisitionStatusClick();
                    break;
                case 'Recruiters':
                    this.selectedRecruitersList = tslib_1.__spread(this.recruitersList);
                    this.onRecruiterClick();
                    break;
                case 'Vendors':
                    this.selectedVendors = tslib_1.__spread(this.vendors);
                    this.onVendorClick();
                    break;
                case 'RequisitionNumbers':
                    this.selectedRequisitionNumbersList = tslib_1.__spread(this.requisitionNumbersList);
                    this.onRequisitionNumbersClick();
                    break;
                case 'JobMatchStates':
                    this.selectedJobMatchStates = tslib_1.__spread(this.jobMatchStates);
                    this.onJobMatchStateClick();
                    break;
                case 'WorkLocations':
                    this.selectedWorkLocationList = tslib_1.__spread(this.workLocationList);
                    this.onWorkLocationClick();
                    break;
                case 'PreferredJobType':
                    this.selectedPreferredJobTypeList = tslib_1.__spread(this.preferredJobTypeList);
                    this.onPreferredJobTypeClick();
                    break;
                case 'jobSubTypes':
                    this.selectedPreferredJobTypeAdditionalList = tslib_1.__spread(this.preferredJobTypeAdditionalList);
                    this.onAdditionalPreferredJobTypeClick();
                    break;
                case 'sponsorships':
                    this.selectedWorkAuthorizationList = tslib_1.__spread(this.workAuthorizationList);
                    this.onWorkAuthorizationClick();
                    break;
                default:
                //do nothing;
            }
        }
        else {
            switch (label) {
                case 'Clients':
                    this.selectedClientOrBuList = [];
                    this.onClientClick();
                    break;
                case 'CandidateStatus':
                    this.selectedCandidateStatusList = [];
                    this.onCandidateStatusClick();
                    break;
                case 'RequisitionStatus':
                    this.selectedRequisitionStatusList = [];
                    this.onRequisitionStatusClick();
                    break;
                case 'Recruiters':
                    this.selectedRecruitersList = [];
                    this.onRecruiterClick();
                    break;
                case 'Vendors':
                    this.selectedVendors = [];
                    this.onVendorClick();
                    break;
                case 'RequisitionNumbers':
                    this.selectedRequisitionNumbers = [];
                    this.onRequisitionNumbersClick();
                    break;
                case 'JobMatchStates':
                    this.selectedJobMatchStates = [];
                    this.onJobMatchStateClick();
                    break;
                case 'WorkLocations':
                    this.selectedWorkLocationList = [];
                    this.onWorkLocationClick();
                    break;
                case 'PreferredJobType':
                    this.selectedPreferredJobTypeList = [];
                    this.onPreferredJobTypeClick();
                    break;
                case 'jobSubTypes':
                    this.selectedPreferredJobTypeAdditionalList = [];
                    this.onAdditionalPreferredJobTypeClick();
                    break;
                case 'sponsorships':
                    this.selectedWorkAuthorizationList = [];
                    this.onWorkAuthorizationClick();
                    break;
                default:
                //do nothing
            }
        }
    };
    CandidatesPageController.prototype.visibilityFilterChanged = function () {
        var _this = this;
        this.onGlobalFilterChange();
        this.getAllRecruiters(function () {
            _this.candidatesContainer.candidatesQueryFilter.visibility = [];
            if (_this.visibilityFilters.assignedToMe != '') {
                _this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToMe');
                if (_this._currentUserExistsInAssignedRecruitersList()) {
                    angular.forEach(_this.recruitersList, function (val, key) {
                        if (val.userId == _this.userId) {
                            val.ticked = true;
                        }
                    });
                }
                else if (!_this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin()) {
                    _this.recruitersList.unshift({ name: _this.userName, selectedDisplayName: _this.$filter('displayOnMultiSelectFilter')(_this.userName), userId: _this.userId, ticked: true });
                }
            }
            else {
                _this.recruitersList = _this.recruitersList.filter(function (recruiter) { return recruiter.userId !== _this.userId; });
            }
            _this.recruitersList = _this.recruitersList.filter(function (recruiter) { return recruiter.userId !== 'UNASSIGNED'; });
            if (_this.visibilityFilters.unassigned != '') {
                _this.candidatesContainer.candidatesQueryFilter.visibility.push('unassigned');
                var unAssignedRecruiter = { name: 'Unassigned', selectedDisplayName: 'Unassigned', userId: 'UNASSIGNED', ticked: true };
                _this.recruitersList.unshift(unAssignedRecruiter);
            }
            _this.selectedRecruitersList = [];
            angular.forEach(_this.recruitersList, function (val, key) {
                if (val.userId !== _this.userId && val.userId !== 'UNASSIGNED') {
                    val.ticked = true;
                }
                if (val.ticked) {
                    _this.selectedRecruitersList.push(val);
                }
            });
            if (_this.visibilityFilters.assignedToOthers != '') {
                _this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToOthers');
            }
            else {
                _this._removeOtherRecruiters();
            }
            if (_this.candidatesContainer.candidatesQueryFilter.visibility.length == 3) {
                _this.candidatesContainer.allAssignedRecruitersCount = _this.recruitersList.length;
            }
            _this.onRecruiterClick();
        });
    };
    CandidatesPageController.prototype.candidateCompensationChanged = function () {
        this.onGlobalFilterChange();
    };
    CandidatesPageController.prototype.onClientClick = function (selectedClients) {
        var _this = this;
        this.isFiltersChanged = true;
        this.getAllRequisitionNumbers(function () {
            _this.getAllRecruiters(function () {
                _this.candidatesContainer.candidatesQueryFilter.clientOrBuList = _this.selectedClientOrBuList.map(function (val, index) {
                    return val.id;
                });
                _this.candidatesContainer.candidatesQueryFilter.requisitionNumbers = _this.selectedRequisitionNumbersList.map(function (val, index) {
                    return val.value;
                });
                _this.candidatesContainer.candidatesQueryFilter.recruiterList = _this.selectedRecruitersList.map(function (val, index) {
                    return val.userId;
                });
                _this.displayCandidateSelectedFilter.clientOrBuList = _this.selectedClientOrBuList.map(function (val, index) {
                    if (val.companyType === 'Corporation') {
                        return val.shortName;
                    }
                    else {
                        return val.name;
                    }
                });
                _this.displayCandidateSelectedFilter.requisitionNumbers = _this.candidatesContainer.candidatesQueryFilter.requisitionNumbers;
                _this.displayCandidateSelectedFilter.recruiterList = _this.selectedRecruitersList.map(function (val, index) {
                    if (val.firstName === null || val.firstName === undefined) {
                        return val.name;
                    }
                    else {
                        return val.firstName;
                    }
                });
                _this.setCandidateDisplayedFilterItemSelected(_this.displayCandidateSelectedFilter);
            });
        });
    };
    CandidatesPageController.prototype.onJobMatchStateClick = function (selectedJobMatches) {
        this.isFiltersChanged = true;
        // set the selected clients on the query filter
        this.candidatesContainer.candidatesQueryFilter.workflowStates = this.selectedJobMatchStates.map(function (val, index) {
            return val.value;
        });
        this.displayCandidateSelectedFilter.workflowStates = this.candidatesContainer.candidatesQueryFilter.workflowStates;
        this.displayCandidateSelectedFilter.workflowStates = this.displayCandidateSelectedFilter.workflowStates.filter(function (val) { return val !== undefined; });
        // Filter Duplicate Values
        this.displayCandidateSelectedFilter.workflowStates = tslib_1.__spread(new Set(this.displayCandidateSelectedFilter.workflowStates));
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    };
    CandidatesPageController.prototype.onWorkLocationClick = function (selectedWorkLocations) {
        this.isFiltersChanged = true;
        // set the selected clients on the query filter
        this.candidatesContainer.candidatesQueryFilter.workLocationIds = this.selectedWorkLocationList.map(function (val, index) {
            return val.id;
        });
        this.displayCandidateSelectedFilter.workLocationIds = this.selectedWorkLocationList.map(function (val, index) {
            return val.name;
        });
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    };
    CandidatesPageController.prototype.onPreferredJobTypeClick = function () {
        this.isFiltersChanged = true;
        this.candidatesContainer.candidatesQueryFilter.jobTypes = this.selectedPreferredJobTypeList.map(function (val, index) {
            return val.value;
        });
        this.displayCandidateSelectedFilter.jobTypes = this.selectedPreferredJobTypeList.map(function (val, index) {
            return val.name;
        });
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
        this.onAdditionalPreferredJobTypeClick();
    };
    CandidatesPageController.prototype.onAdditionalPreferredJobTypeClick = function () {
        this.isFiltersChanged = true;
        if (!this.checkPreferredJobType('CONTRACTTOHIRE') && !this.checkPreferredJobType('CONTRACTOR')) {
            this.selectedPreferredJobTypeAdditionalList = [];
        }
        this.candidatesContainer.candidatesQueryFilter.jobSubTypes = this.selectedPreferredJobTypeAdditionalList.map(function (val, index) {
            return val.value;
        });
        this.displayCandidateSelectedFilter.jobSubTypes = this.selectedPreferredJobTypeAdditionalList.map(function (val, index) {
            return val.name;
        });
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    };
    CandidatesPageController.prototype.checkPreferredJobType = function (jobType) {
        var isJobTypePresent;
        if (this.selectedPreferredJobTypeList && this.selectedPreferredJobTypeList.length > 0) {
            for (var i = 0; i < this.selectedPreferredJobTypeList.length; i++) {
                if (this.selectedPreferredJobTypeList[i].value === jobType) {
                    isJobTypePresent = true;
                    break;
                }
                else {
                    isJobTypePresent = false;
                }
            }
        }
        else {
            isJobTypePresent = false;
        }
        return isJobTypePresent;
    };
    CandidatesPageController.prototype.onWorkAuthorizationClick = function () {
        this.isFiltersChanged = true;
        this.candidatesContainer.candidatesQueryFilter.sponsorships = this.selectedWorkAuthorizationList.map(function (val, index) {
            return val.value;
        });
        this.displayCandidateSelectedFilter.sponsorships = this.selectedWorkAuthorizationList.map(function (val, index) {
            return val.name;
        });
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    };
    CandidatesPageController.prototype.onSalaryDurationChange = function () {
        if (this.candidatesContainer.candidatesQueryFilter.salaryDuration) {
            this.displayCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    };
    CandidatesPageController.prototype.onRateDurationChange = function () {
        if (this.candidatesContainer.candidatesQueryFilter.rateDuration) {
            this.displayCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    };
    CandidatesPageController.prototype.onSalaryOrRateCurrencyChange = function (type) {
        if (this.displayCandidateSelectedFilter.rate != "" || this.displayCandidateSelectedFilter.salary != "") {
            this.displayCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
            this.displayCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
        }
        else if (type === 'salary') {
            this.displayCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
        }
        else {
            this.displayCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    };
    CandidatesPageController.prototype.onCandidateStatusClick = function (selectedCandidateStatus) {
        this.isFiltersChanged = true;
        // set the selected clients on the query filter
        this.candidatesContainer.candidatesQueryFilter.status = this.selectedCandidateStatusList.map(function (val, index) {
            return val.value;
        });
        this.displayCandidateSelectedFilter.status = this.candidatesContainer.candidatesQueryFilter.status;
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    };
    CandidatesPageController.prototype.onRequisitionStatusClick = function (selectedRequisitionStatus) {
        this.isFiltersChanged = true;
        // set the selected requisition statues on the query filter
        this.candidatesContainer.candidatesQueryFilter.requisitionStatus = this.selectedRequisitionStatusList.map(function (val, index) {
            return val.value;
        });
        this.displayCandidateSelectedFilter.requisitionStatus = this.selectedRequisitionStatusList.map(function (val, index) {
            return val.name;
        });
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    };
    CandidatesPageController.prototype.onRecruiterClick = function () {
        this.isFiltersChanged = true;
        // set the selected recruiters on the query filter
        this.candidatesContainer.candidatesQueryFilter.recruiterList = this.selectedRecruitersList.map(function (val, index) {
            return val.userId;
        });
        this.displayCandidateSelectedFilter.recruiterList = this.selectedRecruitersList.map(function (val, index) {
            if (val.firstName === null || val.firstName === undefined) {
                return val.name;
            }
            else {
                return val.firstName;
            }
        });
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    };
    CandidatesPageController.prototype.onVendorClick = function (selectedVendor) {
        this.isFiltersChanged = true;
        // set the selected vendors on the query filter
        this.candidatesContainer.candidatesQueryFilter.vendors = this.selectedVendors.map(function (val, index) {
            return val.id;
        });
        this.displayCandidateSelectedFilter.vendors = this.selectedVendors.map(function (val, index) {
            return val.name;
        });
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    };
    CandidatesPageController.prototype.onRequisitionNumbersClick = function (selectedRequisitionNumbers) {
        var _this = this;
        this.isFiltersChanged = true;
        this.getAllRecruiters(function () {
            _this.candidatesContainer.candidatesQueryFilter.clientOrBuList = _this.selectedClientOrBuList.map(function (val, index) {
                return val.id;
            });
            _this.candidatesContainer.candidatesQueryFilter.requisitionNumbers = _this.selectedRequisitionNumbersList.map(function (val, index) {
                return val.value;
            });
            _this.candidatesContainer.candidatesQueryFilter.recruiterList = _this.selectedRecruitersList.map(function (val, index) {
                return val.userId;
            });
            _this.displayCandidateSelectedFilter.clientOrBuList = _this.selectedClientOrBuList.map(function (val, index) {
                if (val.companyType === 'Corporation') {
                    return val.shortName;
                }
                else {
                    return val.name;
                }
            });
            _this.displayCandidateSelectedFilter.requisitionNumbers = _this.candidatesContainer.candidatesQueryFilter.requisitionNumbers;
            _this.displayCandidateSelectedFilter.recruiterList = _this.selectedRecruitersList.map(function (val, index) {
                if (val.firstName === null || val.firstName === undefined) {
                    return val.name;
                }
                else {
                    return val.firstName;
                }
            });
            _this.setCandidateDisplayedFilterItemSelected(_this.displayCandidateSelectedFilter);
        });
    };
    CandidatesPageController.prototype.sortCandidates = function (sortByFilter, direction) {
        this.isFiltersChanged = true;
        if (_.isNull(sortByFilter)) {
            this.selectedSort = 'Please Select';
            this.selectedSortDirection = '';
            delete this.candidatesContainer.candidatesQueryFilter.column;
            delete this.candidatesContainer.candidatesQueryFilter.sortDirection;
        }
        else {
            this.selectedSort = sortByFilter.columnDisplayName;
            this.candidatesContainer.candidatesQueryFilter.column = sortByFilter.column;
            this.selectedSortDirection = 'Asc';
            this.candidatesContainer.candidatesQueryFilter.sortDirection = 'ASC';
            if (direction == 'Desc') {
                this.selectedSortDirection = 'Desc';
                this.candidatesContainer.candidatesQueryFilter.sortDirection = 'DESC';
            }
            // this.StorageService.set(`candidatesSortFilter-${this.userId}`, {sortBy: sortByFilter, direction: direction});
        }
        this.displayCandidateSelectedFilter.selectedFilterSort = "";
        if (sortByFilter != null) {
            this.displayCandidateSelectedFilter.selectedFilterSort = sortByFilter.columnDisplayName + " " + "(" + direction + ")";
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    };
    CandidatesPageController.prototype.queryCandidates = function () {
        var _this = this;
        this.candidatesContainer.loadingSearchButton = true;
        this.isFiltersChanged = false;
        this.isDisplayRateFilterActive = false;
        this.closeCandidateInfoRow();
        if (this.showFiltersPanel) {
            this._scrollDownToKeepInfiniteScrollActive();
        }
        // clear any existing query requests
        // check for an existing promise and see if it has not been fulfilled yet. If it has not been fulfilled yet, cancel the promise.
        // if(!_.isNull(this.candidatesContainer.currentPromise) && this.candidatesContainer.currentPromise.$$state.status == 0) {
        if (!_.isNull(this.candidatesContainer.currentPromise)) {
            this.genericService.cancelRequest(this.candidatesContainer.currentPromise);
        }
        // reset the initial value of candidates exist flag to true
        this.candidatesContainer.candidatesExistFlag = true;
        // reset the page number to 1 as this is a new query
        this.candidatesContainer.candidatesQueryFilter.pageNum = 1;
        this.currentRequisitionPage = 1;
        // clear the existing candidates
        this.candidatesContainer.candidates = [];
        this.candidatesContainer.disableInfiniteScroll = false;
        this.candidatesContainer.candidatesQueryFilter.workflowStates = this.candidatesContainer.candidatesQueryFilter.workflowStates.filter(function (state) { return state; }); //remove null and undefined values
        // Hide Display Filter
        if (this.candidateFilterItemsSelected.length === 0) {
            this.displayCandidateFilterFlag = false;
            this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon = true;
        }
        // if(!_.isNull(this.candidatesContainer.currentPromise) && this.candidatesContainer.currentPromise.$$state.status == 0) {
        if (!_.isNull(this.candidatesContainer.currentPromise)) {
            // wait for the cancel promise to be fulfilled, if it was called.
            this.$timeout(function () {
                _this.stateManagementStorageService.setScreenState("candidatesScreen-" + _this.userId, _this.candidatesContainer.candidatesQueryFilter);
                _this.stateManagementStorageService.setScreenState("candidatesScreen-displayFilter-" + _this.userId, _this.displayCandidateSelectedFilter);
                if (_this.isRowViewActive) {
                    _this.candidatesContainer.getNextPage(_this.currentRequisitionPage);
                }
                else {
                    _this.candidatesContainer.getNext();
                }
            }, 200);
        }
        else {
            this.stateManagementStorageService.setScreenState("candidatesScreen-" + this.userId, this.candidatesContainer.candidatesQueryFilter);
            this.stateManagementStorageService.setScreenState("candidatesScreen-displayFilter-" + this.userId, this.displayCandidateSelectedFilter);
            if (this.isRowViewActive) {
                this.candidatesContainer.getNextPage(this.currentRequisitionPage);
            }
            else {
                this.candidatesContainer.getNext();
            }
        }
    };
    CandidatesPageController.prototype._scrollDownToKeepInfiniteScrollActive = function () {
        if ($(window).scrollTop() < 100) {
            window.scrollTo(0, 100);
        }
    };
    CandidatesPageController.prototype._setShowCandidateDisplayFilterIcon = function (boolean) {
        var savedDisplayedCandidateSelectedFilter = this.stateManagementStorageService.getScreenState("candidatesScreen-displayFilter-" + this.userId);
        savedDisplayedCandidateSelectedFilter.showCandidateDisplayFilterIcon = boolean;
        this.stateManagementStorageService.setScreenState("candidatesScreen-displayFilter-" + this.userId, savedDisplayedCandidateSelectedFilter);
        if (this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon !== boolean) {
            this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon = boolean;
        }
    };
    CandidatesPageController.prototype._setSalaryAndRateDisplayFilter = function (type) {
        var salaryOrRateFilter = "";
        if (type === 'salary') {
            salaryOrRateFilter = this.candidatesContainer.candidatesQueryFilter.salary ?
                "" + (this.candidatesContainer.candidatesQueryFilter.salary.toString() + " " + this.candidatesContainer.candidatesQueryFilter.currency + " " + this._setDisplayFilterSalaryOrRateDuration('salary')) : "";
        }
        else {
            salaryOrRateFilter = this.candidatesContainer.candidatesQueryFilter.rate ?
                "" + (this.candidatesContainer.candidatesQueryFilter.rate.toString() + " " + this.candidatesContainer.candidatesQueryFilter.currency + " " + this._setDisplayFilterSalaryOrRateDuration('rate')) : "";
        }
        return salaryOrRateFilter;
    };
    CandidatesPageController.prototype._setDisplayFilterSalaryOrRateDuration = function (type) {
        var _this = this;
        var durationOption = "";
        if (type === 'salary') {
            durationOption = this.salaryDurationOptions.filter(function (val) { return _this.candidatesContainer.candidatesQueryFilter.salaryDuration === val.value; })[0].name;
        }
        else {
            durationOption = this.salaryDurationOptions.filter(function (val) { return _this.candidatesContainer.candidatesQueryFilter.rateDuration === val.value; })[0].name;
        }
        return durationOption;
    };
    CandidatesPageController.prototype.displaySelectedFilterToggle = function () {
        this.showCandidateDisplaySelectedFilterPanel = true;
        if (this.displayCandidateFilterFlag) {
            $("#display-candidate-selected-filter-panel").animate({
                height: 'toggle'
            });
            this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon = !this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon;
        }
        // Set Display Filter Collapse and Expand Panel
        this._setShowCandidateDisplayFilterIcon(this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon);
    };
    CandidatesPageController.prototype.isFilterValueArray = function (value) {
        if (Array.isArray(value)) {
            return true;
        }
        else {
            return false;
        }
    };
    CandidatesPageController.prototype.addToDisplayFilters = function (event) {
        switch (event) {
            case 'firstName':
                this.displayCandidateSelectedFilter.firstName = this.candidatesContainer.candidatesQueryFilter.firstName;
                break;
            case 'lastName':
                this.displayCandidateSelectedFilter.lastName = this.candidatesContainer.candidatesQueryFilter.lastName;
                break;
            case 'phone':
                this.displayCandidateSelectedFilter.phone = this.candidatesContainer.candidatesQueryFilter.phone;
                break;
            case 'email':
                this.displayCandidateSelectedFilter.email = this.candidatesContainer.candidatesQueryFilter.email;
                break;
            case 'search':
                this.displayCandidateSelectedFilter.searchString = this.candidatesContainer.candidatesQueryFilter.searchString;
                break;
            case 'salary':
                if (_.isUndefined(this.candidatesContainer.candidatesQueryFilter.salary) || this.candidatesContainer.candidatesQueryFilter.salary < 0) {
                    this.candidatesContainer.candidatesQueryFilter.salary = 1;
                }
                this._checkIfSalaryAndRateDurationDefault('salary');
                this.displayCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
                break;
            case 'rate':
                if (_.isUndefined(this.candidatesContainer.candidatesQueryFilter.rate) || this.candidatesContainer.candidatesQueryFilter.rate < 0) {
                    this.candidatesContainer.candidatesQueryFilter.rate = 1;
                }
                this._checkIfSalaryAndRateDurationDefault('rate');
                this.displayCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
                this.isDisplayRateFilterActive = true;
                break;
            default:
                break;
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    };
    CandidatesPageController.prototype._setObjectVariableName = function (currentObject) {
        var selectedFilterVariableNameObj = {
            requisitionStatus: "Requisition Status", requisitionNumbers: "Requisition Number",
            firstName: "First Name", lastName: "Last Name", phone: "Phone", email: "Email",
            searchString: "Search", workflowStates: "Job Match Status",
            recruiterList: "Recruiter/Hiring Manager", workLocationIds: "Work Locations",
            jobTypes: "Job Type", jobSubTypes: "Additional Contract Types", sponsorships: "Work Authorizations", salary: "Salary",
            rate: "Rate", selectedFilterSort: "Sort By"
        };
        for (var key in selectedFilterVariableNameObj) {
            if (selectedFilterVariableNameObj.hasOwnProperty(key)) {
                var obj = selectedFilterVariableNameObj[key];
                if (key == currentObject.variable) {
                    this.displaySelectedFilterObj.variable = obj;
                }
            }
        }
    };
    CandidatesPageController.prototype.setCandidateDisplayedFilterItemSelected = function (itemsSelected) {
        var _this = this;
        this.emptyCandidateSelectedFilter = false;
        for (var key in itemsSelected) {
            if (itemsSelected.hasOwnProperty(key)) {
                var obj = itemsSelected[key];
                if (obj.length > 0) {
                    this.displayCandidateFilterFlag = true;
                    this.displaySelectedFilterObj = {};
                    if (this.candidateFilterItemsSelected.length !== 0) {
                        this.candidateFilterItemsSelected.forEach(function (filterItem) {
                            if (filterItem.filter == key) {
                                if (filterItem.setSelectedFilterLimit == 5) {
                                    _this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false };
                                }
                                else {
                                    _this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: obj.length, expandSelectedFilter: filterItem.expandSelectedFilter };
                                }
                            }
                        });
                    }
                    if (this.candidateFilterItemsSelected.length == 0 || Object.keys(this.displaySelectedFilterObj).length == 0) {
                        this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false };
                    }
                    this._setObjectVariableName(this.displaySelectedFilterObj);
                    if (this.candidateFilterItemsSelected.length > 0) {
                        this.candidateFilterItemsSelected = this.candidateFilterItemsSelected.filter(function (item) { return item.variable !== _this.displaySelectedFilterObj.variable; });
                    }
                    this.candidateFilterItemsSelected.push(this.displaySelectedFilterObj);
                }
                else {
                    if (this.candidateFilterItemsSelected.length > 0) {
                        this.candidateFilterItemsSelected = this.candidateFilterItemsSelected.filter(function (item) { return item.filter !== key; });
                    }
                }
            }
        }
        if (this.candidateFilterItemsSelected.length === 0) {
            if (!this.candidatesContainer.isFilterOn) {
                this.displayCandidateFilterFlag = false;
                this._setShowCandidateDisplayFilterIcon(true);
            }
            else {
                this.emptyCandidateSelectedFilter = true;
            }
        }
    };
    CandidatesPageController.prototype._setOpenGlobalFilter = function () {
        if (!this.showFiltersPanel) {
            $("#search-panel").animate({
                height: 'toggle'
            });
            this.showFiltersPanel = true;
        }
    };
    CandidatesPageController.prototype._deleteSelectedItem = function (currentObject, deletedItem) {
        var _this = this;
        switch (currentObject.variable) {
            case 'firstName':
                this.candidatesContainer.candidatesQueryFilter.firstName = '';
                this.displayCandidateSelectedFilter.firstName = '';
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
                break;
            case 'lastName':
                this.candidatesContainer.candidatesQueryFilter.lastName = '';
                this.displayCandidateSelectedFilter.lastName = '';
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
                break;
            case 'phone':
                this.candidatesContainer.candidatesQueryFilter.phone = '';
                this.displayCandidateSelectedFilter.phone = '';
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
                break;
            case 'email':
                this.candidatesContainer.candidatesQueryFilter.email = '';
                this.displayCandidateSelectedFilter.email = '';
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
                break;
            case 'searchString':
                this.candidatesContainer.candidatesQueryFilter.searchString = '';
                this.displayCandidateSelectedFilter.searchString = '';
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
                break;
            case 'clientOrBuList':
                this.clientOrBuList.forEach(function (client, index) {
                    if (client.name === deletedItem) {
                        client.ticked = false;
                        _this.selectedClientOrBuList = _this.selectedClientOrBuList.filter(function (item) { return item.name !== deletedItem; });
                    }
                    else if (client.shortName === deletedItem) {
                        client.ticked = false;
                        _this.selectedClientOrBuList = _this.selectedClientOrBuList.filter(function (item) { return item.shortName !== deletedItem; });
                    }
                });
                this.onClientClick();
                break;
            case 'status':
                this.candidateStatusList.forEach(function (canStatus, index) {
                    if (canStatus.value === deletedItem) {
                        canStatus.ticked = false;
                        _this.selectedCandidateStatusList = _this.selectedCandidateStatusList.filter(function (item) { return item.value !== deletedItem; });
                    }
                });
                this.onCandidateStatusClick();
                break;
            case 'requisitionStatus':
                this.requisitionStatusList.forEach(function (reqStatus, index) {
                    if (reqStatus.name === deletedItem) {
                        reqStatus.ticked = false;
                        _this.selectedRequisitionStatusList = _this.selectedRequisitionStatusList.filter(function (item) { return item.name !== deletedItem; });
                    }
                });
                this.onRequisitionStatusClick();
                break;
            case 'requisitionNumbers':
                this.requisitionNumbersList.forEach(function (reqNum, index) {
                    if (reqNum.value === deletedItem) {
                        reqNum.ticked = false;
                        _this.selectedRequisitionNumbersList = _this.selectedRequisitionNumbersList.filter(function (item) { return item.value !== deletedItem; });
                    }
                });
                this.onRequisitionNumbersClick();
                break;
            case 'workflowStates':
                this.jobMatchStates.forEach(function (jobMatch, index) {
                    if (jobMatch.value === deletedItem) {
                        jobMatch.ticked = false;
                        _this.selectedJobMatchStates = _this.selectedJobMatchStates.filter(function (item) { return item.value !== deletedItem; });
                    }
                });
                this.onJobMatchStateClick();
                break;
            case 'vendors':
                this.vendors.forEach(function (vendor, index) {
                    if (vendor.name === deletedItem) {
                        vendor.ticked = false;
                        _this.selectedVendors = _this.selectedVendors.filter(function (item) { return item.name !== deletedItem; });
                    }
                });
                this.onVendorClick();
                break;
            case 'recruiterList':
                this.recruitersList.forEach(function (recruiter, index) {
                    if (recruiter.name === deletedItem) {
                        recruiter.ticked = false;
                        _this.selectedRecruitersList = _this.selectedRecruitersList.filter(function (item) { return item.name !== deletedItem; });
                    }
                    else if (recruiter.firstName === deletedItem) {
                        recruiter.ticked = false;
                        _this.selectedRecruitersList = _this.selectedRecruitersList.filter(function (item) { return item.firstName !== deletedItem; });
                    }
                });
                this.onRecruiterClick();
                break;
            case 'workLocationIds':
                this.workLocationList.forEach(function (workLocation, index) {
                    if (workLocation.name === deletedItem) {
                        workLocation.ticked = false;
                        _this.selectedWorkLocationList = _this.selectedWorkLocationList.filter(function (item) { return item.name !== deletedItem; });
                    }
                });
                this.onWorkLocationClick();
                break;
            case 'jobTypes':
                this.preferredJobTypeList.forEach(function (jobType, index) {
                    if (jobType.name === deletedItem) {
                        jobType.ticked = false;
                        _this.selectedPreferredJobTypeList = _this.selectedPreferredJobTypeList.filter(function (item) { return item.name !== deletedItem; });
                    }
                });
                this.onPreferredJobTypeClick();
                break;
            case 'jobSubTypes':
                this.preferredJobTypeAdditionalList.forEach(function (additionalJobType, index) {
                    if (additionalJobType.name === deletedItem) {
                        additionalJobType.ticked = false;
                        _this.selectedPreferredJobTypeAdditionalList = _this.selectedPreferredJobTypeAdditionalList.filter(function (item) { return item.name !== deletedItem; });
                    }
                });
                this.onAdditionalPreferredJobTypeClick();
                break;
            case 'sponsorships':
                this.workAuthorizationList.forEach(function (sponsorship, index) {
                    if (sponsorship.value === deletedItem) {
                        sponsorship.ticked = false;
                        _this.selectedWorkAuthorizationList = _this.selectedWorkAuthorizationList.filter(function (item) { return item.value !== deletedItem; });
                    }
                    else if (sponsorship.name === deletedItem) {
                        sponsorship.ticked = false;
                        _this.selectedWorkAuthorizationList = _this.selectedWorkAuthorizationList.filter(function (item) { return item.name !== deletedItem; });
                    }
                });
                this.onWorkAuthorizationClick();
                break;
            case 'salary':
                this.candidatesContainer.candidatesQueryFilter.salary = null;
                this.displayCandidateSelectedFilter.salary = "";
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
                break;
            case 'rate':
                this.candidatesContainer.candidatesQueryFilter.rate = null;
                this.displayCandidateSelectedFilter.rate = "";
                this.isDisplayRateFilterActive = false;
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
                break;
            case 'selectedFilterSort':
                this.sortCandidates(null, null);
                break;
            default:
                break;
        }
    };
    CandidatesPageController.prototype.deleteSelectedFilterItem = function (deletedItem) {
        this._setOpenGlobalFilter();
        for (var key in this.displayCandidateSelectedFilter) {
            if (this.displayCandidateSelectedFilter.hasOwnProperty(key)) {
                var obj = this.displayCandidateSelectedFilter[key];
                if (Array.isArray(obj)) {
                    if (obj.includes(deletedItem)) {
                        this.deleteSelectedFilter = {};
                        this.deleteSelectedFilter = { variable: key, value: obj };
                        this._deleteSelectedItem(this.deleteSelectedFilter, deletedItem);
                    }
                }
                else {
                    if (obj == deletedItem) {
                        this.deleteSelectedFilter = {};
                        this.deleteSelectedFilter = { variable: key, value: obj };
                        this._deleteSelectedItem(this.deleteSelectedFilter, deletedItem);
                    }
                }
            }
        }
    };
    CandidatesPageController.prototype.getAllClientsOrBu = function (successCallback) {
        var _this = this;
        this.loadingClientsOrBusFilter = true;
        this.candidateService.getAllClientsOrBu(this.$rootScope.userDetails, function (data) {
            _this.clientOrBuList = data;
            angular.forEach(_this.clientOrBuList, function (clientOrBu, key) {
                if (clientOrBu.companyType == 'Corporation') {
                    clientOrBu.name = "<span style='padding-right:5px'>" + clientOrBu.name + "</span><i class='fas fa-share-alt'></i>";
                }
            });
            if (_this.savedFilters !== null) {
                _this.selectedClientOrBuList = _this.clientOrBuList.filter(function (clientOrBu) { return _this.savedFilters.clientOrBuList.some(function (clientOrBuId) { return clientOrBuId == clientOrBu.id; }); });
                _this.selectedClientOrBuList.forEach(function (clientOrBu) { return clientOrBu.ticked = true; });
            }
            if (_this.savedDisplayedCandidateSelectedFilter.clientOrBuList.length !== 0 || _this.candidatesContainer.candidatesQueryFilter.clientOrBuList.length !== 0) {
                _this.displayCandidateSelectedFilter.clientOrBuList = _this.selectedClientOrBuList.map(function (val, index) {
                    if (val.companyType === 'Corporation') {
                        return val.shortName;
                    }
                    else {
                        return val.name;
                    }
                });
                _this.setCandidateDisplayedFilterItemSelected(_this.displayCandidateSelectedFilter);
            }
            _this.loadingClientsOrBusFilter = false;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.loadingClientsOrBusFilter = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    CandidatesPageController.prototype.getAllJobMatchStates = function (successCallback) {
        var _this = this;
        this.loadingJobMatchStatesFilter = true;
        this.jobMatchService.getAllJobMatchStates(function (data) {
            angular.forEach(data.candidateWorkflowCardStatus, function (stepVal, stepKey) {
                var stepEntry = {};
                stepEntry.name = stepVal.status;
                stepEntry.value = stepVal.status;
                stepEntry.label = "<b>" + stepVal.status + "</b>";
                stepEntry.stepGroup = true;
                _this.jobMatchStates.push(stepEntry);
                angular.forEach(stepVal.states, function (stateVal, stateKey) {
                    var stateEntry = {};
                    stateEntry.name = stateVal;
                    stateEntry.value = stateVal;
                    stateEntry.label = stateVal;
                    stateEntry.ticked = false;
                    _this.jobMatchStates.push(stateEntry);
                });
                stepEntry = {};
                stepEntry.stepGroup = false;
                _this.jobMatchStates.push(stepEntry);
                _this.loadingJobMatchStatesFilter = false;
            });
            if (_this.savedFilters !== null) {
                _this.selectedJobMatchStates = _this.jobMatchStates.filter(function (jobMatchState) { return _this.savedFilters.workflowStates.some(function (stateName) { return stateName == jobMatchState.value; }); });
                _this.selectedJobMatchStates.forEach(function (state) { return state.ticked = true; });
            }
            if (_this.savedDisplayedCandidateSelectedFilter.workflowStates.length !== 0 || _this.candidatesContainer.candidatesQueryFilter.workflowStates.length !== 0) {
                _this.displayCandidateSelectedFilter.workflowStates = _this.selectedJobMatchStates.map(function (val, index) {
                    return val.value;
                });
                _this.displayCandidateSelectedFilter.workflowStates = _this.displayCandidateSelectedFilter.workflowStates.filter(function (val) { return val !== undefined; });
                // Filter Duplicate Values
                _this.displayCandidateSelectedFilter.workflowStates = tslib_1.__spread(new Set(_this.displayCandidateSelectedFilter.workflowStates));
                _this.setCandidateDisplayedFilterItemSelected(_this.displayCandidateSelectedFilter);
            }
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.loadingJobMatchStatesFilter = false;
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CandidatesPageController.prototype.setCandidateInfo = function (candidateInfo, type) {
        var _this = this;
        // if a current container id exits, close it.
        if (!_.isNull(this.candidateInfoContainerId)) {
            this.closeCandidateInfoRow(this.candidateInfoContainerId);
        }
        //$('.candidate-info-container').hide();
        this.infoOfCandidateInContext = candidateInfo;
        var allCandidatesLength = this.candidatesContainer.candidates.length;
        var allCandidatesFullQuadrants = Math.floor(allCandidatesLength / this.divident);
        var currentCandidateQuadrant = Math.ceil(candidateInfo.candidateIndex / this.divident);
        var candidateInfoContainerId = null;
        if (this.isRowViewActive) {
            candidateInfoContainerId = "candidate-info-row-view-" + candidateInfo.candidateIndex;
        }
        else {
            if (currentCandidateQuadrant <= allCandidatesFullQuadrants) {
                candidateInfoContainerId = 'candidate-info-' + (currentCandidateQuadrant * this.divident);
            }
            else {
                candidateInfoContainerId = 'candidate-info-' + allCandidatesLength;
            }
        }
        switch (type) {
            case 'jobMatches':
                this.candidateInfoTemplate = 'app/public/app/partials/missioncontrol/candidates/candidateCard/candidate-job-matches-all.html';
                this.activeTabIndex = 1;
                break;
            case 'possibleJobMatches':
                this.candidateInfoTemplate = 'app/public/app/partials/missioncontrol/candidates/candidateCard/candidate-job-matches-all.html';
                this.activeTabIndex = 2;
                break;
            default:
                this.activeTabIndex = 1;
                break;
        }
        // time out needed for variables to refresh on view and reload the job matches directive.
        this.$timeout(function () {
            _this.candidateInfoContainerId = candidateInfoContainerId;
            candidateInfo.jobMatchesPopoverIsOpenFlag = false;
            $("#" + candidateInfoContainerId).show();
            _this.candidateJobMatchesTabChanged(type);
        }, 100);
    };
    CandidatesPageController.prototype.closeCandidateInfoRow = function () {
        if (!_.isNull(this.candidateInfoContainerId)) {
            $('#' + this.candidateInfoContainerId).hide();
        }
        this.candidateInfoContainerId = null;
        this.sharedAjsService.resetRefreshJobMatchesListener();
        this.candidateJobMatchesTabChanged('jobMatches');
    };
    CandidatesPageController.prototype.getAllCandidateStatuses = function (successCallback) {
        var _this = this;
        this.loadingCandidateStatusesFilter = true;
        this.candidateStatusList = [
            {
                "name": "Active",
                "value": "Active"
            },
            {
                "name": "Passive",
                "value": "Passive"
            },
            {
                "name": "Inert",
                "value": "Inert"
            }
        ];
        if (this.savedFilters !== null) {
            this.selectedCandidateStatusList = this.candidateStatusList.filter(function (status) { return _this.savedFilters.status.some(function (statusName) { return statusName == status.name; }); });
            this.selectedCandidateStatusList.forEach(function (status) { return status.ticked = true; });
        }
        if (this.savedDisplayedCandidateSelectedFilter.status.length !== 0 || this.candidatesContainer.candidatesQueryFilter.status.length !== 0) {
            this.displayCandidateSelectedFilter.status = this.selectedCandidateStatusList.map(function (val, index) {
                return val.value;
            });
            this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
        }
        this.loadingCandidateStatusesFilter = false;
        if (successCallback) {
            successCallback();
        }
    };
    CandidatesPageController.prototype.getAllRequisitionStatuses = function (successCallback) {
        var _this = this;
        this.loadingRequisitionStatusesFilter = true;
        this.jobService.getAllStatusTypes(function (data) {
            _this.requisitionStatusList = data;
            if (_this.savedFilters !== null) {
                _this.selectedRequisitionStatusList = _this.requisitionStatusList.filter(function (status) { return _this.savedFilters.requisitionStatus.some(function (value) { return value == status.value; }); });
                _this.selectedRequisitionStatusList.forEach(function (status) { return status.ticked = true; });
            }
            if (_this.savedDisplayedCandidateSelectedFilter.requisitionStatus.length !== 0 || _this.candidatesContainer.candidatesQueryFilter.requisitionStatus.length !== 0) {
                _this.displayCandidateSelectedFilter.requisitionStatus = _this.selectedRequisitionStatusList.map(function (val, index) {
                    return val.name;
                });
                _this.setCandidateDisplayedFilterItemSelected(_this.displayCandidateSelectedFilter);
            }
            if (successCallback) {
                successCallback();
            }
            _this.loadingRequisitionStatusesFilter = false;
        }, function (error) {
            _this.loadingRequisitionStatusesFilter = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    CandidatesPageController.prototype.getAllWorkLocations = function (successCallback) {
        var _this = this;
        this.loadingWorkLocationsFilter = true;
        this.jobService.getWorkLocations(function (data) {
            _this.workLocationList = data;
            if (_this.savedFilters !== null && _this.savedFilters.workLocationIds) {
                _this.selectedWorkLocationList = _this.workLocationList.filter(function (location) { return _this.savedFilters.workLocationIds.some(function (id) { return location.id === id; }); });
                _this.selectedWorkLocationList.forEach(function (location) { return location.ticked = true; });
            }
            if (_this.savedDisplayedCandidateSelectedFilter.workLocationIds.length !== 0 || _this.candidatesContainer.candidatesQueryFilter.workLocationIds.length !== 0) {
                _this.displayCandidateSelectedFilter.workLocationIds = _this.selectedWorkLocationList.map(function (val, index) {
                    return val.name;
                });
                _this.setCandidateDisplayedFilterItemSelected(_this.displayCandidateSelectedFilter);
            }
            if (successCallback) {
                successCallback();
            }
            _this.loadingWorkLocationsFilter = false;
        }, function (error) {
            _this.loadingWorkLocationsFilter = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    CandidatesPageController.prototype.getAllRecruiters = function (successCallback) {
        var _this = this;
        this.loadingRecruitersFilter = true;
        var clientOrBuId = null;
        var requisitionId = null;
        var clientOrBuIds = this.selectedClientOrBuList.map(function (clientOrBu) {
            return clientOrBu.id;
        });
        var requisitionNumbers = this.selectedRequisitionNumbersList.map(function (reqNumber) {
            return reqNumber.name;
        });
        var isUploadOrEditReq = false;
        this.jobService.getAllRecruiters(this.$rootScope.userDetails, this.$rootScope.userDetails.company, clientOrBuId, requisitionId, clientOrBuIds, requisitionNumbers, isUploadOrEditReq, function (data) {
            _this.recruitersList = data.recruiters;
            angular.forEach(_this.recruitersList, function (val, key) {
                var name = '';
                if (val.lastName !== null) {
                    name = val.firstName + " " + val.lastName;
                }
                else {
                    name = val.firstName;
                }
                val.selectedDisplayName = _this.$filter('displayOnMultiSelectFilter')(name);
                val.name = name.length > 30 ? name.substring(0, 30) + "..." : name;
                val.name = val.name + ' <sup>R</sup>';
            });
            angular.forEach(data.hiringManagers, function (val, key) {
                var name = '';
                if (val.lastName !== null) {
                    name = val.firstName + " " + val.lastName;
                }
                else {
                    name = val.firstName;
                }
                val.selectedDisplayName = _this.$filter('displayOnMultiSelectFilter')(name);
                val.name = name.length > 30 ? name.substring(0, 30) + "..." : name;
                val.name = val.name + ' <sup>H</sup>';
                _this.recruitersList.push(val);
            });
            data.pocs.forEach(function (poc) {
                if (poc) {
                    var name_1;
                    if (poc.lastName !== null) {
                        name_1 = poc.firstName + " " + poc.lastName;
                    }
                    else {
                        name_1 = poc.firstName;
                    }
                    poc.selectedDisplayName = _this.$filter('displayOnMultiSelectFilter')(name_1);
                    poc.name = name_1.length > 30 ? name_1.substring(0, 30) + "..." : name_1;
                    poc.name = poc.name + ' <sup>POC</sup>';
                    _this.recruitersList.push(poc);
                }
            });
            if (_this.visibilityFilters.unassigned != '') {
                if (!_this.recruitersList.find(function (recruiter) { return recruiter.userId == 'UNASSIGNED'; }))
                    ;
                {
                    var unAssignedRecruiter = { name: 'Unassigned', selectedDisplayName: 'Unassigned', userId: 'UNASSIGNED' };
                    _this.recruitersList.unshift(unAssignedRecruiter);
                }
            }
            if (_this.visibilityFilters.assignedToMe != '') {
                if (!_this._currentUserExistsInAssignedRecruitersList() && !_this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin()) {
                    _this.recruitersList.unshift({ name: _this.userName, selectedDisplayName: _this.$filter('displayOnMultiSelectFilter')(_this.userName), userId: _this.userId, ticked: true });
                }
            }
            else {
                _this.recruitersList = _this.recruitersList.filter(function (recruiter) { return recruiter.userId !== _this.userId; });
            }
            _this.selectedRecruitersList = _this.selectedRecruitersList.filter(function (selectedRecruiter) { return _this.recruitersList.find(function (recruiter) { return (recruiter.userId === selectedRecruiter.userId); }); });
            angular.forEach(_this.selectedRecruitersList, function (selectedRecruiter, key) {
                angular.forEach(_this.recruitersList, function (recruiter, index) {
                    if (recruiter.userId == selectedRecruiter.userId) {
                        recruiter.ticked = true;
                    }
                });
            });
            if (_this.savedFilters !== null) {
                _this.selectedRecruitersList = _this.recruitersList.filter(function (recruiter) { return _this.savedFilters.recruiterList.some(function (recruiterId) { return recruiterId == recruiter.userId; }); });
                _this.selectedRecruitersList.forEach(function (recruiter) { return recruiter.ticked = true; });
            }
            if (_this.savedDisplayedCandidateSelectedFilter.recruiterList.length !== 0 || _this.candidatesContainer.candidatesQueryFilter.recruiterList.length !== 0) {
                _this.displayCandidateSelectedFilter.recruiterList = _this.selectedRecruitersList.map(function (val, index) {
                    if (val.firstName === null || val.firstName === undefined) {
                        return val.name;
                    }
                    else {
                        return val.firstName;
                    }
                });
                _this.setCandidateDisplayedFilterItemSelected(_this.displayCandidateSelectedFilter);
            }
            if (successCallback) {
                successCallback();
            }
            _this.loadingRecruitersFilter = false;
        }, function (error) {
            _this.loadingRecruitersFilter = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    CandidatesPageController.prototype._removeOtherRecruiters = function () {
        var _this = this;
        this.recruitersList = this.recruitersList.filter(function (recruiter) { return recruiter.userId == _this.userId || recruiter.userId == 'UNASSIGNED'; });
        this.selectedRecruitersList = tslib_1.__spread(this.recruitersList);
    };
    CandidatesPageController.prototype._currentUserExistsInAssignedRecruitersList = function () {
        var _this = this;
        var exists = this.recruitersList.some(function (recruiter) { return recruiter.userId === _this.userId; });
        return exists;
    };
    CandidatesPageController.prototype.getAllRequisitionNumbers = function (successCallback) {
        var _this = this;
        this.loadingRequisitionNumbersFilter = true;
        var clientOrBuIds = this.selectedClientOrBuList.map(function (clientOrBu) {
            return clientOrBu.id;
        });
        var filter = { clientOrBuIds: clientOrBuIds, roleNames: [] };
        this.jobService.searchByReqNum(this.$rootScope.userDetails.id, this.$rootScope.userDetails.company.companyId, 'all', filter, function (data) {
            _this.requisitionNumbersList = [];
            data.forEach(function (req) {
                var icon = req.sharedRequisition ? '<i class="fas fa-share-alt"></i> ' : '<span class="pl-4"></span>';
                _this.requisitionNumbersList.push({ 'name': req.reqNumber, 'value': req.reqNumber, 'selectedDisplayName': _this.$filter('displayOnMultiSelectFilter')(req.reqNumber), 'icon': icon });
            });
            _this.selectedRequisitionNumbersList = _this.selectedRequisitionNumbersList.filter(function (selectedReqNumber) { return _this.requisitionNumbersList.find(function (reqNumber) { return (reqNumber.name === selectedReqNumber.name); }); });
            angular.forEach(_this.selectedRequisitionNumbersList, function (selectedReqNumber, key) {
                angular.forEach(_this.requisitionNumbersList, function (reqNum, index) {
                    if (reqNum.name == selectedReqNumber.name) {
                        reqNum.ticked = true;
                    }
                });
            });
            if (_this.savedFilters !== null) {
                _this.selectedRequisitionNumbersList = _this.requisitionNumbersList.filter(function (reqNum) { return _this.savedFilters.requisitionNumbers.some(function (num) { return num == reqNum.value; }); });
                _this.selectedRequisitionNumbersList.forEach(function (req) { return req.ticked = true; });
            }
            if (_this.savedDisplayedCandidateSelectedFilter.requisitionNumbers.length !== 0 || _this.candidatesContainer.candidatesQueryFilter.requisitionNumbers.length !== 0) {
                _this.displayCandidateSelectedFilter.requisitionNumbers = _this.selectedRequisitionNumbersList.map(function (val, index) {
                    return val.value;
                });
                _this.setCandidateDisplayedFilterItemSelected(_this.displayCandidateSelectedFilter);
            }
            if (successCallback) {
                successCallback();
            }
            _this.loadingRequisitionNumbersFilter = false;
        }, function (error) {
            _this.loadingRequisitionNumbersFilter = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    CandidatesPageController.prototype.getReqNums = function (searchReqText) {
        var _this = this;
        if (searchReqText == "" || !angular.isDefined(searchReqText)) {
            searchReqText = "all";
        }
        var clientOrBuIds = this.selectedClientOrBuList.map(function (clientOrBu) {
            return clientOrBu.id;
        });
        var filter = { clientOrBuIds: clientOrBuIds, roleNames: [] };
        this.jobService.searchByReqNum(this.$rootScope.userDetails.id, this.$rootScope.userDetails.company.companyId, searchReqText, filter, function (data) {
            _this.requisitionNumbersList = [];
            data.forEach(function (req) {
                var icon = req.sharedRequisition ? '<i class="fas fa-share-alt"></i> ' : '<span class="pl-4"></span>';
                _this.requisitionNumbersList.push({ 'name': req.reqNumber, 'value': req.reqNumber, 'selectedDisplayName': _this.$filter('displayOnMultiSelectFilter')(req.reqNumber), 'icon': icon });
            });
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    CandidatesPageController.prototype.filterByDate = function () {
        this.candidatesContainer.candidatesQueryFilter.fromDate = "";
        this.candidatesContainer.candidatesQueryFilter.toDate = "";
        if (angular.isDefined(this.selectedDateRange) && this.selectedDateRange !== "") {
            var array = this.selectedDateRange.split("-");
            this.candidatesContainer.candidatesQueryFilter.fromDate = array[0].toString().trim();
            this.candidatesContainer.candidatesQueryFilter.toDate = array[1].toString().trim();
        }
        else {
            this.selectedDateRange = "";
        }
    };
    CandidatesPageController.prototype.getAllActivityTypes = function () {
        var _this = this;
        this.jobService.getActivityTypes(function (data) {
            _this.activityMap = [];
            angular.forEach(data, function (val, key) {
                _this.activityMap[val.value] = val.name;
            });
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    CandidatesPageController.prototype.getSalaryDurationOptions = function () {
        var _this = this;
        this.jobService.getSalaryDurationOptions(function (data) {
            _this.salaryDurationOptions = data;
            var tempSalaryDurationOptions = _.cloneDeep(data);
            tempSalaryDurationOptions.map(function (duration) {
                duration.name = duration.name.slice(4);
            });
            _this.filterSalaryDurationOptions = tempSalaryDurationOptions.filter(function (salaryDuration) { return salaryDuration.value === 'PER_YEAR'; });
            _this.filterRateDurationOptions = tempSalaryDurationOptions.filter(function (rateDuration) { return rateDuration.value != 'PER_YEAR'; });
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CandidatesPageController.prototype.getAllPreferredJobTypes = function () {
        var _this = this;
        this.loadingPreferredJobTypeFilter = true;
        this.jobService.getAllJobTypes(function (data) {
            _this.preferredJobTypeList = data;
            _this.preferredJobTypeList.push({ name: "No Pref. Job Type", value: "NO_PREF_JOBTYPE" });
            if (_this.savedFilters !== null && _this.savedFilters.jobTypes) {
                _this.selectedPreferredJobTypeList = _this.preferredJobTypeList.filter(function (jobType) { return _this.savedFilters.jobTypes.some(function (value) { return jobType.value === value; }); });
                _this.selectedPreferredJobTypeList.forEach(function (jobType) { return jobType.ticked = true; });
            }
            if (_this.savedDisplayedCandidateSelectedFilter.jobTypes.length !== 0 || _this.candidatesContainer.candidatesQueryFilter.jobTypes.length !== 0) {
                _this.displayCandidateSelectedFilter.jobTypes = _this.selectedPreferredJobTypeList.map(function (val, index) {
                    return val.name;
                });
                _this.setCandidateDisplayedFilterItemSelected(_this.displayCandidateSelectedFilter);
            }
            _this.loadingPreferredJobTypeFilter = false;
        }, function (error) {
            _this.loadingPreferredJobTypeFilter = false;
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CandidatesPageController.prototype.getAllAdditionalPreferredJobTypes = function () {
        var _this = this;
        this.loadingAdditionalPreferredJobTypeFilter = true;
        this.jobService.getAllJobSubTypes(function (data) {
            _this.preferredJobTypeAdditionalList = data;
            _this.preferredJobTypeAdditionalList.push({ name: 'Not Specified', value: 'NO_PREF_JOBSUBTYPE' });
            if (_this.savedFilters !== null && _this.savedFilters.jobSubTypes) {
                _this.selectedPreferredJobTypeAdditionalList = _this.preferredJobTypeAdditionalList.filter(function (jobType) { return _this.savedFilters.jobSubTypes.some(function (value) { return jobType.value === value; }); });
                _this.selectedPreferredJobTypeAdditionalList.forEach(function (jobType) { return jobType.ticked = true; });
            }
            if (_this.savedDisplayedCandidateSelectedFilter.jobSubTypes.length !== 0 || _this.candidatesContainer.candidatesQueryFilter.jobSubTypes.length !== 0) {
                _this.displayCandidateSelectedFilter.jobSubTypes = _this.selectedPreferredJobTypeAdditionalList.map(function (val, index) {
                    return val.name;
                });
                _this.setCandidateDisplayedFilterItemSelected(_this.displayCandidateSelectedFilter);
            }
            _this.loadingAdditionalPreferredJobTypeFilter = false;
        }, function (error) {
            _this.loadingAdditionalPreferredJobTypeFilter = false;
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CandidatesPageController.prototype.getAllWorkAuthorizations = function () {
        var _this = this;
        this.loadingWorkAuthorizationFilter = true;
        this.jobService.getAllSponsorshipTypes(function (data) {
            _this.workAuthorizationList = data;
            if (_this.savedFilters !== null && _this.savedFilters.sponsorships) {
                _this.selectedWorkAuthorizationList = _this.workAuthorizationList.filter(function (work) { return _this.savedFilters.sponsorships.some(function (value) { return work.value === value; }); });
                _this.selectedWorkAuthorizationList.forEach(function (jobType) { return jobType.ticked = true; });
            }
            if (_this.savedDisplayedCandidateSelectedFilter.sponsorships.length !== 0 || _this.candidatesContainer.candidatesQueryFilter.sponsorships.length !== 0) {
                _this.displayCandidateSelectedFilter.sponsorships = _this.selectedWorkAuthorizationList.map(function (val, index) {
                    return val.name;
                });
                _this.setCandidateDisplayedFilterItemSelected(_this.displayCandidateSelectedFilter);
            }
            _this.loadingWorkAuthorizationFilter = false;
        }, function (error) {
            _this.loadingWorkAuthorizationFilter = false;
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CandidatesPageController.prototype.getCurrencyCodes = function () {
        var _this = this;
        this.jobService.getCurrencyCodes(function (data) {
            _this.currencyCodes = data;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CandidatesPageController.prototype._setSalaryAndRate = function () {
        this.candidatesContainer.candidatesQueryFilter.includeWithoutCompensation = true;
        this._setSalaryAndRateDefaultValues('salary');
        this._setSalaryAndRateDefaultValues('rate');
    };
    CandidatesPageController.prototype._setDisplaySalaryAndRateFilter = function () {
        // Set salary and rate filter
        if (this.displayCandidateSelectedFilter.salary != "" && this.displayCandidateSelectedFilter.rate != "") {
            this.isDisplayRateFilterActive = true;
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    };
    CandidatesPageController.prototype._setSalaryAndRateDefaultValues = function (type) {
        if (type === 'salary') {
            this.candidatesContainer.candidatesQueryFilter.salary = null;
            this.candidatesContainer.candidatesQueryFilter.salaryDuration = "PER_YEAR";
            this.candidatesContainer.candidatesQueryFilter.currency = "USD";
        }
        else {
            this.candidatesContainer.candidatesQueryFilter.rate = null;
            this.candidatesContainer.candidatesQueryFilter.rateDuration = "PER_HOUR";
            this.candidatesContainer.candidatesQueryFilter.currency = "USD";
        }
    };
    CandidatesPageController.prototype._checkIfSalaryAndRateDurationDefault = function (type) {
        if (type === 'salary') {
            if (!this.candidatesContainer.candidatesQueryFilter.salaryDuration || this.candidatesContainer.candidatesQueryFilter.salaryDuration == "") {
                this.candidatesContainer.candidatesQueryFilter.salaryDuration = "PER_YEAR";
            }
        }
        else {
            if (!this.candidatesContainer.candidatesQueryFilter.rateDuration || this.candidatesContainer.candidatesQueryFilter.rateDuration == "") {
                this.candidatesContainer.candidatesQueryFilter.rateDuration = "PER_HOUR";
            }
        }
        if (!this.candidatesContainer.candidatesQueryFilter.currency || this.candidatesContainer.candidatesQueryFilter.currency == "") {
            this.candidatesContainer.candidatesQueryFilter.currency = "USD";
        }
    };
    CandidatesPageController.prototype.deleteCandidate = function (candidateId) {
        if (this.isRowViewActive) {
            var rowViewCandidateIndex = _.findIndex(this.candidatesContainer.candidatesPerPage, { 'id': candidateId });
            this.candidatesContainer.candidatesPerPage.splice(rowViewCandidateIndex, 1);
        }
        else {
            var candidateIndex = _.findIndex(this.candidatesContainer.candidates, { 'id': candidateId });
            this.candidatesContainer.candidates.splice(candidateIndex, 1);
        }
        this.candidatesContainer.candidatesCount = this.candidatesContainer.candidatesCount - 1;
    };
    CandidatesPageController.prototype._handleFilterDisplay = function () {
        var _this = this;
        $(document).ready(function () {
            $("#search-panel").hide();
            $(document).off("click", "#open-filter").on("click", "#open-filter", function () {
                $("#search-panel").animate({
                    height: 'toggle'
                });
                _this.showFiltersPanel = !_this.showFiltersPanel;
            });
        });
    };
    CandidatesPageController.prototype.onGlobalFilterChange = function (event) {
        this.isFiltersChanged = true;
        if (!this.showFiltersPanel) {
            $("#search-panel").animate({
                height: 'toggle'
            });
            this.showFiltersPanel = true;
        }
        if (this._onEnterKeyPress(event)) {
            this.queryCandidates();
        }
    };
    CandidatesPageController.prototype._onEnterKeyPress = function (event) {
        return event && event.keyCode === 13;
    };
    CandidatesPageController.prototype.candidateJobMatchesTabChanged = function (type) {
        this.candidateJobMatchActiveTab.candidateInfoContainerId = this.candidateInfoContainerId;
        this.candidateJobMatchActiveTab.type = type;
    };
    return CandidatesPageController;
}());
export { CandidatesPageController };
var CandidatesContainer = /** @class */ (function () {
    function CandidatesContainer($rootScope, divident, candidateService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.divident = divident;
        this.candidateService = candidateService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.$onInit();
    }
    CandidatesContainer.prototype.$onInit = function () {
        this.candidates = [];
        this.candidatesPerPage = [];
        this.candidatesCount = 0;
        this.busy = false;
        this.loadingSearchButton = false;
        this.candidatesExistFlag = true;
        this.candidatesQueryFilter = new CandidatesQueryFilter(this.$rootScope.userDetails.company.companyId, this.$rootScope.userDetails.id);
        this.currentPromise = null;
        this.disableInfiniteScroll = false;
        this.isFilterOn = false;
        this.allAssignedRecruitersCount = null;
    };
    CandidatesContainer.prototype._getCandidates = function (successCallback, errorCallback) {
        this.currentPromise = this.candidateService.queryCandidateIdNames(this.candidatesQueryFilter, function (data) {
            if (successCallback) {
                successCallback(data);
            }
        }, function (error) {
            if (errorCallback) {
                errorCallback(error);
            }
        });
    };
    CandidatesContainer.prototype.getNext = function () {
        var _this = this;
        if (this.busy)
            return;
        this.busy = true;
        if (this.candidatesQueryFilter.pageNum == '') {
            this.candidatesQueryFilter.pageNum = 1;
        }
        this._setIsFilterOn();
        this._getCandidates(function (data) {
            if (angular.isDefined(data) && data != 'user cancellation') {
                _this.candidatesCount = data.totalCandidateCount;
                if (data.candidatesNameDtos.length > 0) {
                    angular.forEach(data.candidatesNameDtos, function (val, key) {
                        if (key % _this.divident == 0) {
                            val.jobMatchesPopoverPosition = 'bottom-left';
                        }
                        else if ((key + 1) % _this.divident == 0) {
                            val.jobMatchesPopoverPosition = 'bottom-right';
                        }
                        else {
                            val.jobMatchesPopoverPosition = 'bottom';
                        }
                        val.candidateIndex = (_this.candidates.length + 1);
                        val.jobMatchesPopoverIsOpenFlag = false;
                        _this.candidates.push(angular.merge(new Candidate(), val));
                    });
                    // if the length of the returned values is less than page size, it means there are not enough values.
                    // hence we can disable the infinite scroll
                    if (data.candidatesNameDtos.length < _this.candidatesQueryFilter.pageSize) {
                        _this.disableInfiniteScroll = true;
                    }
                    else {
                        _this.candidatesQueryFilter.pageNum++;
                    }
                }
                else {
                    // if the length of the returned values is 0, it means there are no more values.
                    // hence we can disable the infinite scroll
                    _this.disableInfiniteScroll = true;
                }
                // set the candidates exist flag based on existence of candidates.
                if (_this.candidates.length > 0) {
                    _this.candidatesExistFlag = true;
                }
                else {
                    _this.candidatesExistFlag = false;
                }
            }
            _this.busy = false;
            _this.loadingSearchButton = false;
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            _this.busy = false;
            _this.loadingSearchButton = false;
        });
        //console.log('filter object in get next -', this.candidatesQueryFilter);
    };
    CandidatesContainer.prototype.getNextPage = function (currentPage) {
        var _this = this;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (this.busy)
            return;
        this.busy = true;
        this.candidatesQueryFilter.pageNum = currentPage ? currentPage : 1;
        this._setIsFilterOn();
        this.candidatesPerPage = [];
        this._getCandidates(function (data) {
            if (angular.isDefined(data) && data != 'user cancellation') {
                _this.candidatesCount = data.totalCandidateCount;
                if (data.candidatesNameDtos.length > 0) {
                    angular.forEach(data.candidatesNameDtos, function (val, key) {
                        val.candidateIndex = (_this.candidatesPerPage.length + 1);
                        val.jobMatchesPopoverIsOpenFlag = false;
                        _this.candidatesPerPage.push(angular.merge(new Candidate(), val));
                    });
                }
                // set the candidates exist flag based on existence of candidates.
                if (_this.candidatesPerPage.length > 0) {
                    _this.candidatesExistFlag = true;
                }
                else {
                    _this.candidatesExistFlag = false;
                }
            }
            _this.busy = false;
            _this.loadingSearchButton = false;
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            _this.busy = false;
            _this.loadingSearchButton = false;
        });
    };
    CandidatesContainer.prototype._setIsFilterOn = function () {
        var filter = this.candidatesQueryFilter;
        if (filter.status.length > 0
            || (filter.visibility.length == 3 && this.allAssignedRecruitersCount !== null && filter.recruiterList.length == this.allAssignedRecruitersCount)
            || filter.visibility.length < 3
            || filter.roleList.length > 0
            || filter.vendors.length > 0
            || filter.requisitionNumbers.length > 0
            || filter.workflowStates.length > 0
            || (filter.workLocationIds && filter.workLocationIds.length > 0)
            || filter.searchString.length > 0
            || filter.firstName.length > 0
            || filter.lastName.length > 0
            || (filter.email !== undefined && filter.email.length > 0)
            || (filter.phone !== undefined && filter.phone.length > 0)
            || filter.clientOrBuList.length > 0
            || filter.requisitionStatus.length > 0
            || (filter.column !== undefined && filter.sortDirection !== undefined)
            || filter.recruiterList.length > 0) {
            this.isFilterOn = true;
        }
        else {
            this.isFilterOn = false;
        }
    };
    return CandidatesContainer;
}());
CandidatesPageController.$inject = ['$scope', '$rootScope', '$timeout', '$filter', 'StorageService', 'genericService', 'jobService', 'candidateService', 'jobMatchService', 'companyService', 'userRoleService', 'stateManagementStorageService', 'alertsAndNotificationsService', 'MESSAGECONSTANTS', 'sharedAjsService'];
// import * as TEMPLATE from './candidates-page.html';
import * as TEMPLATE from 'raw-loader!./candidates-page.html';
export var CandidatesPageComponent = {
    selector: 'candidatesPage',
    component: {
        bindings: { $transition$: '<' },
        template: TEMPLATE.default,
        // templateUrl: 'app/partials/missioncontrol/candidates/candidates-page.html',
        controller: CandidatesPageController
    }
};
//# sourceMappingURL=candidates-page.component.js.map